<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer title="Add Scratch Card Reward" @hide="cancelModal()">
    <template v-if="show">
      <b-row>
        <b-col sm="12">
          <b-row>
            <b-col sm="5">
              <p-input v-model="form.name" label="Name" name="name" :handler="$v" :formData="form" type="text"/>
            </b-col>
            <b-col sm="4">
              <p-dropdown v-model="form.type" label="Reward Type" name="type" :handler="$v" :formData="form" :options="priceTypeList" textKey="key" textValue="label"/>
            </b-col>
            <b-col sm="3">
              <p-input v-model="form.amount" label="Reward" name="amount" :handler="$v" :formData="form" type="text"/>
            </b-col>
            <b-col sm="12">
              <p-input v-model="form.imageUrl" label="Reward Image" name="imageUrl" :handler="$v" :formData="form" type="text"/>
              <div class="image-wrapper" :style="{width: '220px', height: '380px'}">
                <img :src="form.imageUrl" alt="Reward Image" width="100%" v-if="form.imageUrl !== ''">
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12">
          <b-button variant="success" @click="save()">Save</b-button>
          <b-button variant="outline-danger" @click="cancelModal()">Cancel</b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import { required, numeric } from 'vuelidate/lib/validators'
import { PInput, PDropdown } from '../../../components'

export default {
  name: 'scratchcard-reward-update',
  props: {
    priceTypeList: {
      type: Array,
      default: []
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        name: '',
        imageUrl: '',
        type: null,
        amount: '',
        errorMessages: {
          name: {
            required: 'Scratch Card Name is required.'
          },
          imageUrl: {
            required: 'Please set Image url'
          },
          type: {
            required: 'Please select Price Type'
          },
          amount: {
            required: 'Amount is required',
            numeric: 'Must be number'
          }
        }
      }
    }
  },
  validations: {
    form: {
      name: { required },
      type: { required },
      amount: { required, numeric },
      imageUrl: { required }
    }
  },
  components: {
    PInput,
    PDropdown
  },
  computed: {
    show: {
      get: function () {
        return this.showModal
      },
      set: function () {
        return this.showModal
      }
    }
  },
  methods: {
    async save () {
      try {
        Events.$emit('loader')
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return
        }
        await this.$http.post(this.API_ENDPOINT + '/scratchcard/reward/add', {
          name: this.form.name,
          imageUrl: this.form.imageUrl,
          type: this.form.type,
          amount: this.form.amount
        }, { headers: { 'Content-Type': 'application/json' } })
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Update Successful')
        this.cancelModal()
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    cancelModal () {
      this.form.name = ''
      this.form.imageUrl = ''
      this.form.type = null
      this.form.amount = ''
      this.$v.form.$reset()
      this.$emit('closeModal')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/scratchcard/rewards/AddReward.vue